/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetSitesResponseData,
  GetSitesResponseDataFromJSON,
  GetSitesResponseDataFromJSONTyped,
  GetSitesResponseDataToJSON
} from './GetSitesResponseData'

/**
 *
 * @export
 * @interface GetSitesResponse
 */
export interface GetSitesResponse {
  /**
   *
   * @type {number}
   * @memberof GetSitesResponse
   */
  status?: number
  /**
   *
   * @type {GetSitesResponseData}
   * @memberof GetSitesResponse
   */
  data?: GetSitesResponseData
}

export function GetSitesResponseFromJSON(json: any): GetSitesResponse {
  return GetSitesResponseFromJSONTyped(json, false)
}

export function GetSitesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSitesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetSitesResponseDataFromJSON(json['data'])
  }
}

export function GetSitesResponseToJSON(value?: GetSitesResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetSitesResponseDataToJSON(value.data)
  }
}
